<template>
  <div class="flex flex-row justify-start items-center">
    <div
      :class="[
        'flex flex-row justify-start items-center border-b-4 w-full h-10',
        `border-${color}`,
      ]"
    >
      <slot name="icon"></slot>
    </div>
    <div class="flex flex-row">
      <div :class="['border-fix border-b-4', `border-${color}`]"></div>
      <button
        @click.prevent="$router.push(url)"
        :class="['border-4 rounded-full h-10', `border-${color}`]"
        style="width: 184px;"
      >
        <div class="flex flex-row items-center">
          <slot name="btn-content"></slot>
        </div>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopPageTableHeader',

  props: {
    color: {
      type: String,
      default: 'blue',
    },
    url: {
      type: String,
      default: '',
    },
  },
}
</script>
